module.exports = __webpack_public_path__ + "static/img/bg5-hover.3cca8005.png";